import styled from '@emotion/styled'
export const StyleRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
export const StyleHalfWrapper = styled.div`
  width: 49%;
`

export const StyleSampleWrapper = styled.div`
  border-radius: 8px;
  background: ${(props: any) => props.theme.colors.secondary150};
  padding: 15px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
